export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_03.9db2c479.jpg";